import React, { Component, createRef } from 'react';
import { NavLink } from 'react-router-dom';
import styles from './NavBar.module.css';

import { getCurrentResource } from '../../util/tools';
import {getUserInfo, canViewForm, hasAccess} from '../../util/localStorage';

import {
	FORM_AUTHORITY_AUTHOR_TABLE,
	FORM_AUTHORITY_PUBLISHER_TABLE,
	FORM_BOOK_TABLE,
	FORM_BOOKSHOP_TABLE,
	FORM_CONFIRMATION_TABLE,
	FORM_CONTACT_TABLE,
	FORM_DERIVATIVE_TABLE,
	FORM_DIGITAL_STORE_TABLE,
	FORM_EBOOK_BANK_TABLE,
	FORM_EBOOK_MERCHANT_TABLE,
	FORM_EBOOK_PAYMENT_TABLE,
	FORM_EBOOK_REPORT_TABLE,
	FORM_EBOOK_REPORT_ITEM_TABLE,
	FORM_EBOOK_SUPPLIER_TABLE,
	FORM_EBOOK_TERMINAL_TABLE,
	FORM_ESTIMATION_TABLE,
	FORM_EVENT_TABLE,
	FORM_HONOR_TABLE,
	FORM_KATOTTG_TREE,
	FORM_LIBRARY_TABLE,
	FORM_LOCATION_TABLE,
	FORM_LOG_TABLE,
	FORM_MESSAGE_TABLE,
	FORM_MREPORT_TABLE,
	FORM_MREPORT_ITEM_TABLE,
	FORM_OFFER_TABLE,
	FORM_ONIX_LOG_TABLE,
	FORM_ORDER_TABLE,
	FORM_ORGANIZATION_TABLE,
	FORM_PROCUREMENT_TABLE,
	FORM_PRODUCT_TABLE,
	FORM_PROVIDER_TABLE,
	FORM_REQUEST_TABLE,
	FORM_REQUEST_ITEM_TABLE,
	FORM_ROLE_TABLE,
	FORM_TOPIC_TABLE,
	FORM_USER_GROUP_TABLE,
	FORM_USER_TABLE,
	FORM_WORK_TABLE,

	FORM_DBMANAGER,
	FORM_OPTIONS,
} from '../../util/consts/forms';
import { ACC_MREPORT } from '../../util/consts/actions';

import {
	HELLO_PATH,
	DBMANAGER_PATH,
	SYSTEM_OPTIONS_PATH,
	SYSINFO_PATH,
	
	AUTHORITY_AUTHOR_TABLE_PATH,
	AUTHORITY_PUBLISHER_TABLE_PATH,
	BOOK_TABLE_PATH,
	BOOKSHOP_TABLE_PATH,
	CONFIRMATION_TABLE_PATH,
	CONTACT_TABLE_PATH,
	DERIVATIVE_TABLE_PATH,
	DIGITAL_STORE_TABLE_PATH,
	EBOOK_BANK_TABLE_PATH,
	EBOOK_MERCHANT_TABLE_PATH,
	EBOOK_PAYMENT_TABLE_PATH,
	EBOOK_REPORT_TABLE_PATH,
	EBOOK_REPORT_ITEM_TABLE_PATH,
	EBOOK_SUPPLIER_TABLE_PATH,
	EBOOK_TERMINAL_TABLE_PATH,
	ESTIMATION_TABLE_PATH,
	EVENT_TABLE_PATH,
	HONOR_TABLE_PATH,
	KATOTTG_TREE_PATH,
	LIBRARY_TABLE_PATH,
	LOCATION_TABLE_PATH,
	LOG_TABLE_PATH,
	MESSAGE_TABLE_PATH,
	MREPORT_TABLE_PATH,
	MREPORT_ITEM_TABLE_PATH,
	OFFER_TABLE_PATH,
	ONIX_LOG_TABLE_PATH,
	ORDER_TABLE_PATH,
	ORGANIZATION_TABLE_PATH,
	PROCUREMENT_TABLE_PATH,
	PRODUCT_TABLE_PATH,
	PROVIDER_TABLE_PATH,
	REQUEST_TABLE_PATH,
	REQUEST_ITEM_TABLE_PATH,
	ROLE_TABLE_PATH,
	TOPIC_TABLE_PATH,
	USER_GROUP_TABLE_PATH,
	USER_TABLE_PATH,
	WORK_TABLE_PATH
} from '../../util/routes';


class NavBar extends Component {
	
	constructor(props) {
		super(props);
		this.resource = getCurrentResource().components.navigation.NavBar;
		this.userInfo = getUserInfo(); 
		this.state = {
			userInfo: this.userInfo
		}
		this.menuCatalog = {
			title: this.resource.menuCatalog,
			items: [
				{path: AUTHORITY_AUTHOR_TABLE_PATH, form: FORM_AUTHORITY_AUTHOR_TABLE, title: this.resource.tfAuthorityAuthorTitle},
				{path: AUTHORITY_PUBLISHER_TABLE_PATH, form: FORM_AUTHORITY_PUBLISHER_TABLE, title: this.resource.tfAuthorityPublisherTitle},
				{path: WORK_TABLE_PATH, form: FORM_WORK_TABLE, title: this.resource.tfWorkTitle},
				{path: BOOK_TABLE_PATH, form: FORM_BOOK_TABLE, title: this.resource.tfBookTitle},
				{path: DERIVATIVE_TABLE_PATH, form: FORM_DERIVATIVE_TABLE, title: this.resource.tfDerivativeTitle},
				{path: HONOR_TABLE_PATH, form: FORM_HONOR_TABLE, title: this.resource.tfHonorTitle},
				{path: TOPIC_TABLE_PATH, form: FORM_TOPIC_TABLE, title: this.resource.tfTopicTitle},
			]
		};
		this.menuProducts = {
			title: this.resource.menuProducts,
			items: [
				{path: MESSAGE_TABLE_PATH, form: FORM_MESSAGE_TABLE, title: this.resource.tfMessageTitle},
				{path: PRODUCT_TABLE_PATH, form: FORM_PRODUCT_TABLE, title: this.resource.tfProductTitle},
				{path: CONFIRMATION_TABLE_PATH, form: FORM_CONFIRMATION_TABLE, title: this.resource.tfConfirmationTitle},
				{path: OFFER_TABLE_PATH, form: FORM_OFFER_TABLE, title: this.resource.tfOfferTitle},
				{path: ORDER_TABLE_PATH, form: FORM_ORDER_TABLE, title: this.resource.tfOrderTitle},
				{path: REQUEST_TABLE_PATH, form: FORM_REQUEST_TABLE, title: this.resource.tfRequestTitle},
				{path: REQUEST_ITEM_TABLE_PATH, form: FORM_REQUEST_ITEM_TABLE, title: this.resource.tfRequestItemTitle},
				{path: PROCUREMENT_TABLE_PATH, form: FORM_PROCUREMENT_TABLE, title: this.resource.tfProcurementTitle},
				{path: ESTIMATION_TABLE_PATH, form: FORM_ESTIMATION_TABLE, title: this.resource.tfEstimationTitle},
			]
		};
		this.menuSubjects = {
			title: this.resource.menuSubjects,
			items: [
				{path: EBOOK_BANK_TABLE_PATH, form: FORM_EBOOK_BANK_TABLE, title: this.resource.tfEBookBankTitle},
				{path: PROVIDER_TABLE_PATH, form: FORM_PROVIDER_TABLE, title: this.resource.tfProviderTitle},
				{path: BOOKSHOP_TABLE_PATH, form: FORM_BOOKSHOP_TABLE, title: this.resource.tfBookShopTitle},
				{path: LIBRARY_TABLE_PATH, form: FORM_LIBRARY_TABLE, title: this.resource.tfLibraryTitle},
				{path: ORGANIZATION_TABLE_PATH, form: FORM_ORGANIZATION_TABLE, title: this.resource.tfOrganizationTitle},
				{path: CONTACT_TABLE_PATH, form: FORM_CONTACT_TABLE, title: this.resource.tfContactTitle},
				{path: EVENT_TABLE_PATH, form: FORM_EVENT_TABLE, title: this.resource.tfEventTitle},
				{path: LOCATION_TABLE_PATH, form: FORM_LOCATION_TABLE, title: this.resource.tfLocationTitle},
				{path: EBOOK_MERCHANT_TABLE_PATH, form: FORM_EBOOK_MERCHANT_TABLE, title: this.resource.tfEBookMerchantTitle},
				{path: EBOOK_TERMINAL_TABLE_PATH, form: FORM_EBOOK_TERMINAL_TABLE, title: this.resource.tfEBookTerminalTitle},
			]
		};
		this.menuMonitor = {
			title: this.resource.menuMonitor,
			items: [
				{path: MREPORT_TABLE_PATH, form: FORM_MREPORT_TABLE, title: this.resource.tfMReportTitle},
				{path: MREPORT_ITEM_TABLE_PATH, form: FORM_MREPORT_ITEM_TABLE, title: this.resource.tfMReportItemTitle},
			]
		};
		this.menuEBook = {
			title: this.resource.menuEBook,
			items: [
				{path: EBOOK_SUPPLIER_TABLE_PATH, form: FORM_EBOOK_SUPPLIER_TABLE, title: this.resource.tfEBookSupplierTitle},
				{path: EBOOK_PAYMENT_TABLE_PATH, form: FORM_EBOOK_PAYMENT_TABLE, title: this.resource.tfEBookPaymentTitle},
				{path: EBOOK_REPORT_TABLE_PATH, form: FORM_EBOOK_REPORT_TABLE, title: this.resource.tfEBookReportTitle},
				{path: EBOOK_REPORT_ITEM_TABLE_PATH, form: FORM_EBOOK_REPORT_ITEM_TABLE, title: this.resource.tfEBookReportItemTitle},
			]
		};
		this.menuAdmin = {
			title: this.resource.menuAdmin,
			items: [
				{path: USER_GROUP_TABLE_PATH, form: FORM_USER_GROUP_TABLE, title: this.resource.tfUserGroupTitle},
				{path: USER_TABLE_PATH, form: FORM_USER_TABLE, title: this.resource.tfUserTitle},
				{path: ROLE_TABLE_PATH, form: FORM_ROLE_TABLE, title: this.resource.tfRoleTitle},
				{path: DIGITAL_STORE_TABLE_PATH, form: FORM_DIGITAL_STORE_TABLE, title: this.resource.tfDigitalStoreTitle},
				{path: KATOTTG_TREE_PATH, form: FORM_KATOTTG_TREE, title: this.resource.tfKatottgTitle},
				{path: ONIX_LOG_TABLE_PATH, form: FORM_ONIX_LOG_TABLE, title: this.resource.tfOnixLogTitle},
				{path: LOG_TABLE_PATH, form: FORM_LOG_TABLE, title: this.resource.tfLogTitle},
				{path: DBMANAGER_PATH, form: FORM_DBMANAGER, title: this.resource.formDbmanagerTitle},
				{path: SYSTEM_OPTIONS_PATH, form: FORM_OPTIONS, title: this.resource.formSystemOptionsTitle},
				{path: SYSINFO_PATH, title: this.resource.formSystemInfoTitle},
			]
		};
	}
	
	render() {
		let menuMonitorHtml = null;
		if( hasAccess(ACC_MREPORT, this.userInfo) )
			menuMonitorHtml = (<Menu holder={this} menu={this.menuMonitor} />); 
		return (
			<div className={styles.divMenuBar}>
				<div className={styles.divMenu}>
					<a className={styles.aLink} href={HELLO_PATH}>{this.resource.formMainTitle}</a>
				</div>
				<Menu holder={this} menu={this.menuCatalog} />
				<Menu holder={this} menu={this.menuProducts} />
				<Menu holder={this} menu={this.menuSubjects} />
				{menuMonitorHtml}
				<Menu holder={this} menu={this.menuEBook} />
				<Menu holder={this} menu={this.menuAdmin} />
			</div>
		);
	}
}

function Link(props) {
	const { form, path, userInfo, title } = props;
	if( userInfo == null || canViewForm(form, userInfo) )
		return <NavLink to={path} className={styles.navLinkPassive} activeClassName={styles.navLinkActive}>{title}</NavLink>
	else
		return null;
}

class Menu extends React.Component  {
	
	constructor(props) {
		super(props);
	}
	
	render() {
		let userInfo = this.props.holder.state.userInfo;
		let menu = this.props.menu;
		let activeMenu = [];
		for( let item of menu.items ) {
			if( userInfo == null || canViewForm(item.form, userInfo) ) {
				activeMenu.push( item );
			}
		}
		if( activeMenu.length == 0 )
			return null;
			
		let dropdownContentHtml = activeMenu.map( (item, index) => {
			const link = document.createElement('a');
			link.href = item.path;
			document.body.appendChild(link);
			return (
				<div key={index} className={styles.divDropdownItem}  > {/* onClick={() => { link.click() }} */}
					<a href={item.path} style={{display: 'block'}}>{item.title}</a>
				</div>
			);
		});
		
		return (
			<div className={styles.divDropdown}>
				<button className={styles.buttonDropdown}>{menu.title}</button>
				<div className={styles.divDropdownContent}>
					{dropdownContentHtml}
				</div>
			</div> 
		);
	}
}
export default NavBar;
